(function( $ ) {
    $(".news-item-switcher").slick({
       rows: 0,
       slidesToShow: 4
    });

    const $mainImage = $(".homepage-latest-news .image");
    const $mainTitle = $(".homepage-latest-news .news-item-data h3");
    const $mainExcerpt = $(".homepage-latest-news .news-item-data p");
    const $mainLink = $(".homepage-latest-news .news-item-data .links #post-permalink");

    $(".news-item-selector").on("click", function () {
        $(".news-item-selector.active").removeClass('active');
        let $title = $(this).children("span.title").text();
        let $excerpt = $(this).children("span.excerpt").text();
        let $link = $(this).children("span.link").text();
        let $background = $(this).children("span.background").text();

        $mainTitle.text($title);
        $mainExcerpt.text($excerpt);
        $mainLink.attr("href", $link);
        $mainImage.css("background-image", 'url('+$background+')');
        $(this).addClass('active');
    });
})(jQuery);